import angular from 'angular';
import ConfigsFactory from './configs.factory';

let ConfigsModule = angular.module('app.configs', [])

.factory('Configs', ConfigsFactory)

.name;

export default ConfigsModule;


// WEBPACK FOOTER //
// ./client/app/common/configs/index.js